import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useCart } from "../stores/cartStore";
import { useMoney } from "../stores/currenciesStore";

const ProductCard = ({
    product = {
        id: null,
        slug: '',
        name: '',
        price: 0,
        computed_price: 0,
        images: [],
    },
    badgeText = undefined,
    badgeColor = undefined
}) => {
    const {t} = useTranslation()
    // Ensure we have valid price values
    const safePrice = product.price || 0;
    const safeComputedPrice = product.computed_price || 0;
    const samePrice = safePrice === safeComputedPrice;
    const [quantity, setQuantity] = useState(1);
    const { addToCart } = useCart();

    const handleAddToCart = (e) => {
        e.preventDefault();
        addToCart(product, quantity);
        setQuantity(1); // Reset quantity after adding to cart
    };

    const incrementQuantity = () => setQuantity(quantity + 1);
    const decrementQuantity = () => setQuantity(quantity > 1 ? quantity - 1 : quantity);

    const {money} = useMoney()

    return (
        <div className="p-16 border border-gray-100 w-100 product-card h-100 hover-border-main-600 rounded-16 position-relative transition-2">
            <Link
                to={`/products/${product.slug}`}
                className="tw-w-full flex-center rounded-8 bg-gray-50 position-relative"
            >
                <img
                    src={product.images?.length > 0 ? product.images[0] : 'assets/images/thumbs/product-two-img1.png'}
                    alt=""
                    className="tw-object-cover tw-h-full tw-w-full tw-aspect-square"
                />
                {
                    badgeText && (
                        <span className={`px-8 py-4 text-sm text-white product-card__badge position-absolute inset-inline-start-0 inset-block-start-0 ${badgeColor || 'bg-primary-600'}`}>
                            {badgeText}{" "}
                        </span>
                    )
                }
            </Link>
            <div className="tw-mt-2 xl:tw-mt-4 product-card__content">
                <h6 className="mt-12 mb-8 text-lg title fw-semibold">
                    <Link
                        to={`/products/${product.slug}`}
                        className="link text-line-4"
                        tabIndex={0}
                    >
                        {product.name}
                    </Link>
                </h6>
                <div className="tw-my-2 xl:tw-my-4 product-card__price">
                    {
                        !samePrice && (
                            <span className={`text-gray-400 text-md fw-semibold text-decoration-line-through tw-mr-1`}>
                                {money(safePrice)}
                            </span>
                        )
                    }
                    <span className="text-lg text-heading fw-semibold">
                        {money(safeComputedPrice)}{" "}
                    </span>
                </div>
                <div className="gap-8 mb-16 d-flex flex-column">
                    <div className="overflow-hidden d-flex rounded-4">
                        <button onClick={decrementQuantity}
                            type="button"
                            className="flex-shrink-0 w-32 h-32 quantity__minus text-neutral-600 bg-gray-50 flex-center hover-bg-main-600 hover-text-white"
                        >
                            <i className="ph ph-minus" />
                        </button>
                        <input
                            type="number"
                            className="w-32 px-8 text-center border border-gray-100 quantity__input flex-grow-1 border-start-0 border-end-0"
                            value={quantity}
                            readOnly
                        />
                        <button onClick={incrementQuantity}
                            type="button"
                            className="flex-shrink-0 w-32 h-32 quantity__plus text-neutral-600 bg-gray-50 flex-center hover-bg-main-600 hover-text-white"
                        >
                            <i className="ph ph-plus" />
                        </button>
                    </div>
                </div>
                <button
                    onClick={handleAddToCart}
                    className="gap-8 px-24 product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 rounded-8 flex-center fw-medium w-100"
                    tabIndex={0}
                >
                    {t('common.addToCart')} <i className="ph ph-shopping-cart" />
                </button>
            </div>
        </div>
    )
}

export default ProductCard;